import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { BrandsFitersType, ListBrands } from '@/state/brands/models'
import {
  GlobalUIActions,
  setDialogAction,
} from '@/state/ui/global/slices/index.slices'
import { TableHeadCellPropsType, useAppDispatch } from '@/state'

import { ApplicationState } from '@/state/root.models'
import { DialogsEnum } from '@/enums'
import { BrandsLibraryColumnProps } from '@/state/user/models'

import { useBrandsActions } from './use-brands-actions.hook'

export const useBrandsTable = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const { brands, isLoading } = useSelector(
    ({ brands }: ApplicationState) => brands,
  )

  const { deleteBrand, setCurrentBrand } = useBrandsActions()

  const [brandFilters, setBrandsFilters] = useState<BrandsFitersType>()

  const [listBrands, setListBrands] = useState(brands)

  let headCells: TableHeadCellPropsType<BrandsLibraryColumnProps>[] = [
    { id: 'enable', label: t('labels.enable'), width: 100 },
    { id: 'name', label: t('name'), width: 100 },
    { id: 'siteId', label: t('labels.siteId'), width: 100 },
    { id: 'operatorId', label: t('labels.gameStoreId'), width: 150 },
    { id: 'currencies', label: t('labels.currencies'), width: 250 },
  ]

  headCells =
    process.env.REACT_APP_STAGE === 'prod'
      ? headCells.filter((head) => head.id !== 'operatorId')
      : headCells

  const handleDeleteBrand = (
    anchorPosition: { top: number; left: number },
    brandId: number,
  ) => {
    dispatch(
      GlobalUIActions.setPopoverConfirmAction({
        action: t('messages.delete'),
        anchorPosition,
        open: true,
        type: t('brand').toLowerCase(),
        handler: () => deleteBrand(brandId),
      }),
    )
  }

  const handleEditBrand = (id: number) => {
    setCurrentBrand(brands.find((brands: ListBrands) => brands.siteId === id))
    dispatch(
      setDialogAction({
        open: true,
        id: DialogsEnum.DIALOG_BRAND_FORM,
      }),
    )
  }

  const handleBrandFilters = (filters: BrandsFitersType) => {
    setBrandsFilters((prevState) => ({ ...prevState, ...filters }))

    const filteredBrands = brands.filter(
      (brand) =>
        (filters.name
          ? brand.name.toLowerCase().includes(filters.name.toLowerCase())
          : true) &&
        (filters.siteId
          ? brand.siteId
              .toString()
              .toLowerCase()
              .includes(filters.siteId.toString().toLowerCase())
          : true),
    )

    setListBrands(filteredBrands)
  }

  useEffect(() => {
    setListBrands(brands)
  }, [brands])

  return {
    handleDeleteBrand,
    handleEditBrand,
    handleBrandFilters,
    isLoading,
    brands: listBrands,
    brandFilters,
    headCells,
  }
}
